import { Paper, Title, Text, Divider, Stack } from "@mantine/core";

function Blog20231001() {
  return (
    <Paper
      p="xl"
      radius="lg"
      withBorder
      shadow="sm"
      mt="lg"
      mx="auto"
      maw={700}
    >
      <Stack gap="md">
        <Title order={1}>10/1/2023: On Time and Moving On</Title>
        <Divider />
        <Title order={2} size="h3">
          It's 1:12 AM.
        </Title>
        <Text>
          I woke up yesterday to my dad asking me if I wanted to go with him on
          a hike, but I was too tired from staying up to play games with some
          friends. The good, healthy thing probably would've been to join him
          anyways, regardless of how tired I was. I'm tired every day and I have
          to do things every day anyways, so why shouldn't I go? I went back to
          sleep, telling him that I'd go next week. But what will change about
          next week? Will I not feel tired on a Saturday morning? It's hard to
          say, but how many times can we kick things to the next week before
          there is no next week?
        </Text>
        <Text>
          Eventually time catches up to us and there is no more next time.
        </Text>
        <Text>
          An aside: Maybe part of the problem is that I'm tired every day. But
          even if I'm tired, I still have to do things. I still wake up to
          volunteer (albeit consistently a bit late). I still wake up to work or
          go to work. I still wake up to greet the day, day after day. Maybe I
          avoid waking up because I subconsciously associate waking up with the
          expectations and responsibilities of living in a society. Although I'm
          probably not the only one who avoids waking up because revenge bedtime
          procrastination is a thing. I'd probably be a lot less tired if I just
          slept earlier or exercised regularly. Although it's hard to live for
          the future when the present seems so bleak. Maybe the world is getting
          better, but it seems like every step forward is hard-fought and
          suffers the risk of getting set back multiple steps. How do we effect
          change in a society that is scared of the future? Shirking away from
          all the possibilities for the future because some outcomes may be bad?
          Have we become so pessimistic that we are driven to inaction for fear
          of what action could bring? We probably maintain the status quo
          because that is what is easy, not because it is what is right.
        </Text>
        <Text>
          It is always fun meeting up with people, friends, and acquaintances.
          Although when it gets to the time to go, there is always a certain
          bittersweet feeling. I pretty much always say something along the
          lines of, "until next time," as a goodbye since there are no good
          goodbyes. Then we may not talk for days, days that turn into weeks,
          weeks that turn into months, and then months that turn into years.
          There may not actually be a next time, who knows what'll happen in the
          future? Like friends or coworkers who say that you should stay in
          touch and you just don't. It's not like you actually dislike the other
          person in any sense of the word or that you don't actually want to
          stay in touch, but life gets in the way. We live our lives from moment
          to moment. Then we look back, thinking where the time went. At times
          it feels like time is ephemeral, and at other times it may feel
          agonizingly long. There is no time. Yet we have all the time in the
          world (or at least the time granted to us by the genetic lottery,
          luck, and maybe some margin of error (read: wiggle room) based on some
          measure of self-care).
        </Text>
        <Text>
          In the universe of people, this probably isn't an uncommon occurrence.
          There is nothing fundamentally wrong with this because every person is
          their own, with their own thoughts and living their own lives with
          autonomy or at least however much autonomy is granted to them in the
          system we exist and participate in. (Because in reality we are only
          living our lives in a fashion that is begrudgingly accepted by the
          oppressors, with every comfort and right granted to us through
          collective action. Also note that rights and opportunities for some
          groups is still unequal because some things about society are
          fundamentally broken.) Relationships are a two-way street that
          requires both parties to maintain lest it falls into disrepair. We
          weave in and out of each others lives, so how do you make these
          interactions meaningful? Not pointless? How can we spend our time
          together such that it moves the metaphorical needle? The people we
          spend every day with may not always be around, so how can we derive
          meaning from our interactions?
        </Text>
        <Text>
          Everyone probably lives with some sort of existential angst, but maybe
          it is just more at the forefront for some than others. Or they
          distract themselves with life keeping busy such that they don't need
          to think about it? The sense of existential dread hanging at the back
          of everyone's mind. "What am I doing?" "Who am I?" "Am I enough? What
          does that even mean?"
        </Text>
        <Title order={2} size="h3">
          I got home from Seattle a few hours ago from a friend's going away
          party.
        </Title>
        <Text>If they ever read this, however unlikely, "Hi! xD"</Text>
        <Text>
          It's not like they'll be gone forever or that I'd never see them again
          out in this vast world. Will things fundamentally change? Probably? I
          spent a lot of time with them in college (per aspera ad astra and
          whatnot) and saw them like once a week for the last couple of years
          and it was always nice or good to spend time with them. So this
          goodbye was especially bittersweet, but people must move on. They must
          move on to the next chapter of their lives, to tackle bigger, better
          things. There is generally no guarantee that things will always be
          better or that life will be good, as life will always have its mix of
          ups and downs. Sometimes all we can do is hope that nothing goes wrong
          in this system that is barely held together by duct tape and dreams.
        </Text>
        <Text>
          I'd never tell them this in person, but they're probably one of the
          best people I know. Not because they're particularly good at
          everything they do (which is also not to say that they aren't good at
          every thing they try), but because of how real they are. I've
          interacted with this person over the years, saw them obtain hobbies
          that came and went and came back again, worked with them and watched
          them learn new things; essentially change and grow as a person. People
          change all the time, but it's interesting to reflect on all the
          changes over time. In a few words, they are chaotic, strong-willed,
          and raw. They actively look for new experiences or excuses to try new
          things and dragged people along with her. They are someone that pushes
          people up and forward rather than beat them down.
        </Text>
        <Text>
          It has historically been unsaid and there have been many times when I
          have said a last farewell (sometimes unknowingly), but I hope that
          people know that even if I never see or speak to them again in the
          rest of our short lives, I am rooting for them. Come what may with
          expectation and ambition, wherever you are or whatever you're trying
          to accomplish, I am rooting for you. To be human and mortal is to
          struggle and burn like a star against the pitch-black void that just
          wants to extinguish all light and life.
        </Text>
        <Text>
          I guess times change, for better or worse (but hopefully for the
          better 🙂).
        </Text>
        <Text>
          May we meet in better times and better places. Until next time.
        </Text>
      </Stack>
    </Paper>
  );
}

export default Blog20231001;
